module.exports = __webpack_public_path__ + "img/5-1account.3604d947.png";